<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        <p v-if="alert.type !== 'danger'">
          {{alert.message}}
        </p>
        <ul v-else>
          <li v-for="e in alert.message">
            {{e}}
          </li>
        </ul>
      </b-alert>
    </template>
    <div class="box box-primary">
      <file-upload @alert="alert" @toggle="loading = !loading" :pagination="pagination"></file-upload>
      <div class="clear"></div>
      <div class="box-body">
        <div class="row">
          <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12"></div>
          <div class="col-xs-12">
            <edit-file-modal id="editFileModal" :file="modalFile" @close="closeModal" @alert="alert($event)"></edit-file-modal>
            <div class="table table-responsive" v-if="pagination.data.length > 0">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{'created' | translate}}</th>
                    <th class="min-width-45">{{'title' | translate}}</th>
                    <th>{{'type' | translate}}</th>
                    <th>{{'size' | translate}}</th>
                    <th>{{'download' | translate}}</th>
                    <th>{{'edit' | translate}}</th>
                    <th>{{'delete' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="file in pagination.data">
                    <td>{{file.id}}</td>
                    <td class="small">
                      {{file.created | orderDate}}<br/>
                      <span class="text-muted">
                        <i class="fa fa-clock-o mr-5"></i>
                        {{file.created| orderDate(true)}}
                      </span>
                    </td>
                    <td>
                      {{file.title}} <br>
                      <small class="text-muted">{{file.subtitle}}</small>
                    </td>
                    <td>
                      <i class="fa fa-file-pdf-o mr-5"></i>
                      {{file.type}}
                    </td>
                    <td>
                      <small>{{file.size}} Kb</small>
                    </td>
                    <td>
                      <a class="btn btn-sm btn-outline no-margin" :href="file.path" target="_blank">
                        <i class="fa fa-cloud-download mr-5"></i>
                        {{'download' | translate}}
                      </a>
                    </td>
                    <td>
                      <button
                        class="btn btn-sm btn-info no-margin"
                        data-toggle="modal"
                        data-target="#editFileModal"
                        @click="openModal(file.id)"
                        >
                        <i class="fa fa-edit mr-5"></i>
                        {{'edit' | translate}}
                      </button>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-danger no-margin" @click="sendData('DELETE', file)">
                        <i class="fa fa-trash-o mr-5"></i>
                        {{'delete' | translate}}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
            No files to show
          </div>
          </div>
        </div>
      </div>
      <div class="overlay" v-show="loading">
        <img class="loading-gif" src="/static/img/blabla.svg"/>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </section>
</template>
<script>
  import FileUpload from '../tools/FileUpload.vue'

  export default {
    data() {
      return {
        edit: [],
        alerts: [],
        loading: false,
        pagination: {
          total: 0,
          per_page: 25,
          current_page: 1,
          total_pages: 0,
          data: []
        },
        modalFile: {}
      }
    },
    components: {
      fileUpload: FileUpload
    },
    computed: {},
    methods: {
      openModal(fileId) {
        for (let singleFile in this.pagination.data) {
          if (this.pagination.data[singleFile].id === fileId) {
            this.modalFile = this.pagination.data[singleFile]
            console.log(this.modalFile)
          }
        }
      },
      closeModal() {
        this.loading = true
        this.refresh('PUT')
      },
      sendData(method, data = {note: this.noteBody}) {
        let extra = ''
        extra = '/' + data.id
        this.loading = true
        API({method: method, url: 'files' + extra, data: data})
          .then(response => {
            this.loading = false
            this.alerts.push({dismiss: 4, type: 'success', message: 'Success', icon: 'icon fa fa-check', show: true})
            this.refresh(method === 'PUT' ? data.id : true)
          })
          .catch(error => {
            this.alerts.push({
              dismiss: 4,
              type: 'danger',
              message: [error.response.data.message],
              icon: 'icon fa fa-check',
              show: true
            })
            this.loading = false
          })
      },
      editFile(id) {
        this.edit[id] = true
        this.edit = [...this.edit]
      },
      alert(value) {
        this.alerts.push(value)
        this.refresh()
      },
      refresh(flag) {
        API.get('files')
          .then(response => {
            this.pagination = response.data
            if (flag) {
              this.edit[flag] = false
              this.pagination.data.forEach(n => {
                n.original_title = n.title
                n.original_sub = n.subtitle
                this.loading = false
              })
            } else {
              this.pagination.data.forEach(n => {
                this.edit[n.id] = false
                n.original_title = n.title
                n.original_sub = n.subtitle
                this.loading = false
              })
            }
          })

      },
      paginate (type, value) {
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
        if (value === 'previous') {
          url += (this.pagination.current_page - 1)
        }
        if (value === 'next') {
          url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
        } else if (value !== 'next' && value !== 'previous') {
          url += value
        }
        API.get(`files${url}`)
            .then(response => {
              this.pagination = response.data
          })
        }
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.refresh()
      })
    },
    watch: {
      pagination(value) {
        this.pagination = value
      }
    }
  }
</script>

<style>
  .overlay {
    z-index: 50;
    background: rgba(33, 34, 40, .75);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 110%;
  }

  .overlay > .fa {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -1rem;
    margin-top: -1rem;
    color: currentColor;
    font-size: 2rem;
    opacity: 0.65;
  }

  .min-width-45 {
    min-width: 45%;
  }
</style>
<style scoped>
  .loading-gif {
    display: block;
    width: 5%;
    top: 42%;
    left: 50%;
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Uploader.vue